import { OutletEntryModal } from '../types'

type GetOutletEntryModalParams = {
  /** Logged in status from the client context fetch, `null` until it settles */
  isLoggedIn: boolean | null
  isClientContextFetchPending: boolean
  isCompanyUser: boolean
  isTableOrder: boolean
  isOutletClosed: boolean
}

export default function getOutletEntryModal({
  isLoggedIn,
  isClientContextFetchPending,
  isCompanyUser,
  isTableOrder,
  isOutletClosed,
}: GetOutletEntryModalParams) {
  // Guests get an (anonymous) client context too, so wait for it to settle
  // before deciding between the company and guest flows
  if (isLoggedIn == null || isClientContextFetchPending) {
    return OutletEntryModal.None
  }

  // Company users pick a time from the company calendar, which also
  // works while the restaurant is closed right now
  if (isCompanyUser && !isTableOrder) {
    return OutletEntryModal.CompanyOrderTime
  }

  if (isOutletClosed) {
    return OutletEntryModal.OutletClosed
  }

  if (!isTableOrder) {
    return OutletEntryModal.ServiceTimeKindSelection
  }

  return OutletEntryModal.None
}
